const SELECTOR = '.slider';
const BREAKPOINT_PX_PER_SLIDE = 240;
const MAX_VISIBLE_SLIDES = 5;
let swiperCount = 1;

const SLIDER_DEFAULTS = {
	loop: true,
	loopAdditionalSlides: 3,
	spaceBetween: 32,
};

const AUTOPLAY = {
	autoplay: {
		delay: 8000,
	},
};

const FADE = {
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
};

const NAVIGATION_PAGINATION = {
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next',
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
};

const NAVIGATION = {
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next',
	},
};

const PAGINATION = {
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
};

const CENTER_SLIDES = {
	centeredSlides: true,
};

const SMALL_GUTTERS = {
	spaceBetween: 15,
};

const WIDE_GUTTERS = {
	spaceBetween: 60,
};

const AUTO_HEIGHT = {
	autoHeight: true,
}

function initializeSliders() {

	const { Swiper } = window;

	if (!Swiper) {
		return;
	}

	const sliders = [...document.querySelectorAll(SELECTOR)];
	sliders.forEach(s => new Swiper(prepareSlider(s), getSliderConfig(s)));
}

function prepareSlider(slider) {
	const slideWrapper = slider.querySelector('.slides');
	const slides = [...slideWrapper.children];

	slideWrapper.classList.add('swiper-wrapper');
	slides.forEach(s => {
		const sSlide = document.createElement('div');
		sSlide.classList.add('swiper-slide');

		s.parentNode.insertBefore(sSlide, s);
		sSlide.appendChild(s);
	});

	if (slider.classList.contains('has-pagination') && (slides.length > 1)) {
		const sPagination = document.createElement('div');
		sPagination.classList.add('swiper-pagination');

		slider.appendChild(sPagination);
	}

	if ((slider.classList.contains('has-navigation') || slider.classList.contains('has-mobile-navigation')) && (slides.length > 1)) {
		const sPrev = document.createElement('div');
		sPrev.classList.add(`swiper-button-prev-${swiperCount}`);
		sPrev.classList.add('swiper-button-prev');
		slider.parentNode.appendChild(sPrev);

		const sNext = document.createElement('div');
		sNext.classList.add(`swiper-button-next-${swiperCount}`);
		sNext.classList.add('swiper-button-next');
		slider.parentNode.appendChild(sNext);

		slider.parentNode.classList.add('slider-outer-wrapper');
	}

	if (slider.classList.contains('has-navigation-pagination') && (slides.length > 1)) {
		const sPrev = document.createElement('div');
		sPrev.classList.add(`swiper-button-prev-${swiperCount}`);
		sPrev.classList.add('swiper-button-prev');
		slider.appendChild(sPrev);

		const sNext = document.createElement('div');
		sNext.classList.add(`swiper-button-next-${swiperCount}`);
		sNext.classList.add('swiper-button-next');
		slider.appendChild(sNext);

		const sPagination = document.createElement('div');
		sPagination.classList.add('swiper-pagination');
		slider.parentNode.appendChild(sPagination);
	}

	return slider;
}

function getSliderBreakpoints(slidesPerView) {
	if (slidesPerView < 2) {
		return null;
	}

	const breakpoints = {
		1: {
			slidesPerView: 1,
		}
	};

	const pxPerSlide = BREAKPOINT_PX_PER_SLIDE;

	for (let n = 2; n <= Math.min(slidesPerView, MAX_VISIBLE_SLIDES); n++) {
		const bkpt = pxPerSlide * n;

		if (bkpt <= 480) {
			breakpoints[bkpt] = {
				slidesPerView: 1,
			}
		} else {
			breakpoints[bkpt] = {
				slidesPerView: n,
			};
		}
	}
	return breakpoints;
}

function getSliderConfig(slider) {
	if (slider.dataset.sliderConfig) {
		return JSON.parse(slider.dataset.sliderConfig);
	}

	const settings = [SLIDER_DEFAULTS];
	const slides = slider.querySelectorAll('.slides > *');

	if (slider.classList.contains('has-autoplay')) {
		settings.push(AUTOPLAY);
	}

	if (slider.classList.contains('has-transition-fade')) {
		settings.push(FADE);
	}

	if (slider.classList.contains('has-navigation-pagination') && slides.length > 1) {
		let navigation_pagination = NAVIGATION_PAGINATION;

		navigation_pagination.navigation.prevEl = navigation_pagination?.navigation?.prevEl + '-' + swiperCount;
		navigation_pagination.navigation.nextEl = navigation_pagination?.navigation?.nextEl + '-' + swiperCount;

		settings.push(NAVIGATION_PAGINATION);
	}

	if (slider.classList.contains('has-pagination') && slides.length > 1) {
		settings.push(PAGINATION);
	}

	if ((slider.classList.contains('has-navigation') || slider.classList.contains('has-mobile-navigation')) && (slides.length > 1)) {
		let navigation = NAVIGATION;

		navigation.navigation.prevEl = navigation?.navigation?.prevEl + '-' + swiperCount;
		navigation.navigation.nextEl = navigation?.navigation?.nextEl + '-' + swiperCount;
		settings.push(NAVIGATION);
	}

	swiperCount++;

	if (slider.classList.contains('center-slides')) {
		settings.push(CENTER_SLIDES);
	}

	if (slider.classList.contains('small-gutters')) {
		settings.push(SMALL_GUTTERS);
	}

	if (slider.classList.contains('wide-gutters')) {
		settings.push(WIDE_GUTTERS);
	}

	if (slider.classList.contains('has-auto-height')) {
		settings.push(AUTO_HEIGHT);
	}

	let { slidesPerView, breakpoints } = slider.dataset;

	if (slidesPerView) {
		if (slidesPerView === 'auto') {
			settings.push({ slidesPerView });
		} else if (slidesPerView > 1) {
			settings.push({
				slidesPerView,
				breakpoints: getSliderBreakpoints(slidesPerView)
			});
		}

		//Fixes the responsive issue for the sliders which don't have the option for centered slides.
		if (!slider.classList.contains('center-slides')) {
			if (breakpoints !== undefined) {
				const obj = JSON.parse(breakpoints);
				const append = Object.assign({
					0: {
						slidesPerView: 1,
						centeredSlides: true,
					},
					600: {
						slidesPerView: 2,
						centeredSlides: false,
					},
					900: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					1200: {
						slidesPerView: 4,
						centeredSlides: false,
					},
				}, obj);

				breakpoints = JSON.stringify(append);
			} else if (slider.dataset.slidesPerView == 3) {
				const append = {
					0: {
						slidesPerView: 1,
						centeredSlides: true,
					},
					700: {
						slidesPerView: 2,
						centeredSlides: false,
					},
					1100: {
						slidesPerView: 3,
						centeredSlides: false,
					},
				};

				breakpoints = JSON.stringify(append);
			} else if (slider.dataset.slidesPerView == 4) {
				const append = {
					0: {
						slidesPerView: 1,
						centeredSlides: true,
					},
					420: {
						slidesPerView: 2,
						centeredSlides: false,
					},
					640: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 4,
						centeredSlides: false,
					},
				};

				breakpoints = JSON.stringify(append);
			} else if (slider.dataset.slidesPerView >= 5) {
				const append = {
					0: {
						slidesPerView: 2,
						centeredSlides: true,
					},
					600: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					900: {
						slidesPerView: 4,
						centeredSlides: false,
					},
					1200: {
						slidesPerView: 5,
						centeredSlides: false,
					},
				};

				breakpoints = JSON.stringify(append);
			}
		}

		if (slider.classList.contains('speakers-slider')) {
			if (slider.dataset.slidesPerView >= 5) {
				const obj = '';
				const append = Object.assign({
					0: {
						slidesPerView: 1,
						centeredSlides: false,
					},
					500: {
						slidesPerView: 2,
						centeredSlides: false,
					},
					700: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					900: {
						slidesPerView: 4,
						centeredSlides: false,
					},
					1200: {
						slidesPerView: 5,
						centeredSlides: false,
					},
				}, obj);

				breakpoints = JSON.stringify(append);
			}
		}

		if (slider.classList.contains('logo-slider')) {
			if (slider.dataset.slidesPerView >= 5) {
				const obj = '';
				const append = Object.assign({
					0: {
						slidesPerView: 1,
						centeredSlides: false,
					},
					420: {
						slidesPerView: 2,
						centeredSlides: false,
					},
					640: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 5,
						centeredSlides: false,
					},
				}, obj);

				breakpoints = JSON.stringify(append);
			}
		}
	}

	if (breakpoints) {
		settings.push({ breakpoints: JSON.parse(breakpoints) });
	}

	const output = Object.assign({}, ...settings);

	if (slides.length < 2) {
		output.loop = false;
		output.slidesPerView = 1;

		slider.classList.remove('has-navigation');
		slider.classList.remove('preview-adjacent-slides');
	}

	return output;
}

document.addEventListener('DOMContentLoaded', initializeSliders);
